import React from 'react';
import { t } from 'ttag';
import { Heading, RadioButton } from '../../../../components';

function CustomizationQuestion({
  isCustomizationEnabled,
  toggleCustomization,
}) {
  return (
    <>
      <Heading
        as="h3"
        noMargin
      >{t`Would you like to customize your product before adding it to the cart?`}</Heading>
      <div className="mt-4">
        <RadioButton
          id="noCustomization"
          name="Customization"
          isChecked={isCustomizationEnabled === false}
          onChange={() => toggleCustomization(false)}
          value="False"
        >
          {t`No, Thank you.`}
        </RadioButton>
        <RadioButton
          id="enabledCustomization"
          name="Customization"
          isChecked={isCustomizationEnabled}
          onChange={() => toggleCustomization(true)}
          value="True"
        >
          {t`Yes, I would like to customize my product.`}
        </RadioButton>
      </div>
    </>
  );
}

export default CustomizationQuestion;
